<div class="card card-nav-tabs mt-0 rounded-lg border-0 shadow-lg">
    <div class="collapse show">
        <div class="card-body">
            <div class="compliance-monitoring-program-accordion border-0 rounded-lg">
                <!-- Header -->
                <div class="compliance-monitoring-program-header" @click.stop="toggle_program('trust-form')">
                    <div class="d-flex justify-content-between align-items-start w-100">
                        <div class="d-flex align-items-start">
                            <i class="bi mt-1" :class="is_trust_form_open ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
                            <div class="compliance-monitoring-icon-bg-primary ms-2 mt-1">
                                <i class="bi bi-folder-fill"></i>
                            </div>
                            <div class="ms-3">
                                <p class="mb-0 text-xs fw-bold">Questionnaire</p>
                            </div>
                        </div>
                        <div class="program-meta d-flex align-items-start">
                            <button
                                class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-white"
                                data-bs-toggle="modal"
                                data-bs-target="#verification_results_modal"
                                @click.stop
                            >
                                Auto Verify
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Results -->
                <div v-if="is_trust_form_open" class="compliance-monitoring-projects-wrapper">
                    <!-- Main: Answers -->
                    <div class="compliance-monitoring-project-accordion border table-border-color rounded-lg mb-3">
                        <div class="compliance-monitoring-project-header" @click="toggle_expanded('answers')">
                            <div class="compliance-monitoring-project-connector"></div>
                            <div class="d-flex align-items-center">
                                <i class="bi" :class="expanded_index === 'answers' ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
                                <div class="compliance-monitoring-icon-bg-jade ms-2">
                                    <i class="bi bi-file-earmark-text"></i>
                                </div>
                                <div class="ms-3">
                                    <p class="mb-0 text-xs">Answers</p>
                                    <p class="mb-0 text-xxs text-muted">{{ last_updated }}</p>
                                </div>
                            </div>
                        </div>

                        <!-- Answers Content -->
                        <div v-if="expanded_index === 'answers'" class="compliance-monitoring-project-details">
                        <div class="bg-white border rounded p-3">
                            <p class="mb-2 text-xs fw-bold">Questionnaire Responses</p>

                            <form class="row g-3">
                            <!-- Normal input -->
                            <div class="col-12">
                                <label for="company_name" class="form-label text-xxs text-muted mb-1">Company Name</label>
                                <input
                                type="text"
                                class="form-control form-control-sm"
                                id="company_name"
                                placeholder="Enter company name"
                                value="ABC PTY LTD"
                                />
                            </div>

                            <!-- Normal input -->
                            <div class="col-12">
                                <label for="reg_number" class="form-label text-xxs text-muted mb-1">Registration Number</label>
                                <input
                                type="text"
                                class="form-control form-control-sm"
                                id="reg_number"
                                placeholder="e.g. 2019/123456/07"
                                value="2019/123456/07"
                                />
                            </div>

                            <!-- Textarea -->
                            <div class="col-12">
                                <label for="business_address" class="form-label text-xxs text-muted mb-1">Business Address</label>
                                <textarea
                                id="business_address"
                                class="form-control form-control-sm"
                                rows="3"
                                placeholder="Enter business address"
                                >123 Main St, Sandton, 2196</textarea>
                            </div>

                            <!-- Radio group -->
                            <div class="col-12">
                                <div class="mb-1 text-xxs text-muted">Company Type</div>
                                <div class="form-check">
                                <input class="form-check-input" type="radio" name="company_type" id="ct_private" checked>
                                <label class="form-check-label text-xs" for="ct_private">Private Company (Pty) Ltd</label>
                                </div>
                                <div class="form-check">
                                <input class="form-check-input" type="radio" name="company_type" id="ct_public">
                                <label class="form-check-label text-xs" for="ct_public">Public Company (Ltd)</label>
                                </div>
                                <div class="form-check">
                                <input class="form-check-input" type="radio" name="company_type" id="ct_close">
                                <label class="form-check-label text-xs" for="ct_close">Close Corporation (CC)</label>
                                </div>
                            </div>

                            <!-- Checkbox group -->
                            <div class="col-12">
                                <div class="mb-1 text-xxs text-muted">Services Offered</div>
                                <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="svc_consulting" checked>
                                <label class="form-check-label text-xs" for="svc_consulting">Consulting</label>
                                </div>
                                <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="svc_sales">
                                <label class="form-check-label text-xs" for="svc_sales">Sales</label>
                                </div>
                                <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="svc_support" checked>
                                <label class="form-check-label text-xs" for="svc_support">Support</label>
                                </div>
                            </div>

                            <!-- Directors -->
                            <div class="col-12">
                                <label for="directors" class="form-label text-xxs text-muted mb-1">Directors</label>
                                <input
                                type="text"
                                class="form-control form-control-sm"
                                id="directors"
                                placeholder="Comma-separated names"
                                value="Jane Doe, John Smith"
                                />
                            </div>
                            </form>
                        </div>
                        </div>
                    </div>

                    <!-- Main: Verification -->
                    <div class="compliance-monitoring-project-accordion border table-border-color rounded-lg">
                        <div class="compliance-monitoring-project-header" @click="toggle_expanded('verification')">
                            <div class="compliance-monitoring-project-connector"></div>
                            <div class="d-flex align-items-center">
                                <i class="bi" :class="expanded_index === 'verification' ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
                                <div class="compliance-monitoring-icon-bg-jade ms-2">
                                    <i class="bi bi-shield-check"></i>
                                </div>
                                <div class="ms-3">
                                    <p class="mb-0 text-xs">Verification</p>
                                    <p class="mb-0 text-xxs text-muted">{{ verification_results.length }} services available</p>
                                </div>

                            </div>
                        </div>

                        <!-- Verification Service Cards -->
                        <div v-if="expanded_index === 'verification'" class="compliance-monitoring-project-details">
                            <div class="row g-3">
                                <div 
                                    class="col-md-12" 
                                    v-for="(service, index) in verification_results" 
                                    :key="index"
                                >
                                    <div 
                                        class="service-card card h-100 shadow-sm"
                                        :class="get_servicecard_class(service.status)"
                                    >
                                        <div class="card-header bg-transparent border-0 pb-0">
                                            <div class="d-flex justify-content-between align-items-start">
                                                <div class="d-flex align-items-center">
                                                    <div class="compliance-monitoring-icon-bg-jade me-2">
                                                        <i class="bi" :class="get_service_icon(service.type)"></i>
                                                    </div>
                                                    <div>
                                                        <h6 class="mb-0 text-xs fw-bold">{{ service.label }}</h6>
                                                        <small class="text-muted text-xxs">{{ service.date }}</small>
                                                    </div>
                                                </div>
                                                <span class="badge bg-light text-dark border text-xxs">
                                                    {{ service.status }}
                                                </span>
                                            </div>
                                        </div>
                                        
                                        <div class="card-body pt-2">
                                            <button 
                                                class="btn btn-outline-secondary btn-sm w-100 text-xxs mb-2"
                                                @click="toggle_service_details(index)"
                                            >
                                                <i class="bi" :class="expanded_service === index ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                                                {{ expanded_service === index ? 'Hide Details' : 'View Details' }}
                                            </button>
                                            
                                            <!-- Service Details -->
                                            <div v-if="expanded_service === index" class="mt-3">
                                                <div class="bg-light rounded p-2">
                                                    <div 
                                                        v-for="(val, key) in service.details" 
                                                        :key="key"
                                                        class="d-flex justify-content-between align-items-center py-1"
                                                    >
                                                        <small class="text-muted">{{ format_key(key) }}:</small>
                                                        <small class="fw-semibold">
                                                            <template v-if="Array.isArray(val)">{{ val.join(', ') }}</template>
                                                            <template v-else-if="typeof val === 'boolean'">{{ val ? 'Yes' : 'No' }}</template>
                                                            <template v-else>{{ val }}</template>
                                                        </small>
                                                    </div>
                                                </div>
                                                
                                                <div class="mt-2 d-flex gap-1">
                                                    <button class="btn btn-success btn-sm text-xxs flex-fill" v-if="service.status === 'Pending'">
                                                        <i class="bi bi-check-circle me-1"></i>Approve
                                                    </button>
                                                    <button class="btn btn-outline-primary btn-sm text-xxs flex-fill">
                                                        <i class="bi bi-arrow-clockwise me-1"></i>Retry
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Modal -->
<teleport to="body">
<div
  class="modal fade"
  id="verification_results_modal"
  ref="verification_results"
  tabindex="-1"
  aria-labelledby="verification_results_label"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="verification_results_label">Verification services for Trust Compliance</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p class="fw-bold text-x">Select Services</p>

        <div class="container">
          <div class="row">
            <div class="col-md-6 mb-3" v-for="(service, index) in verification_services" :key="index">
              <div class="d-flex justify-content-between align-items-center border rounded p-3 shadow-sm bg-light">
                <div>
                  <p class="mb-1 text-xxs fw-bold">{{ service.name }}</p>
                  <small class="text-muted text-xxs">{{ service.description }}</small>
                </div>
                <label class="text-xxs">
                  <input type="checkbox" v-model="service.selected" class="form-check-input">
                </label>
              </div>
            </div>

          </div>
          <div class="d-flex justify-content-end gap-2 mt-2 text-xxs">
            <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="auto_verification">
              Start verification
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
</teleport>
